/**
 * Explorer “Documents” PDFs live under `public/docs/mindtime-explorer/<slug>`.
 * Same-origin URLs allow the HTML `download` attribute to suggest the filename.
 */

export type ExplorerDocumentItem = {
  id: string;
  label: string;
  size: string;
  slug: string;
};

export const EXPLORER_GENERAL_DOCUMENTS: ExplorerDocumentItem[] = [
  {
    id: 'gen-cancellation',
    label: 'Cancellation Form User Online Backup.pdf',
    size: '66.28 kB',
    slug: 'cancellation-form-user-online-backup.pdf',
  },
  {
    id: 'gen-iso27001',
    label: 'ISO 27001 Certificate.pdf',
    size: '2.39 MB',
    slug: 'iso-27001-certificate.pdf',
  },
  {
    id: 'gen-msp',
    label: 'MSP Agreement.pdf',
    size: '2.38 MB',
    slug: 'msp-agreement.pdf',
  },
  {
    id: 'gen-nen7510',
    label: 'NEN 7510 Certificate.pdf',
    size: '2.39 MB',
    slug: 'nen-7510-certificate.pdf',
  },
  {
    id: 'gen-sla',
    label: 'Service Level Agreement.pdf',
    size: '1.39 MB',
    slug: 'service-level-agreement.pdf',
  },
  {
    id: 'gen-terms',
    label: 'Terms and conditions and Data Processing Agreement.pdf',
    size: '1.37 MB',
    slug: 'terms-and-conditions-data-processing-agreement.pdf',
  },
];

/** Four rows; reuses the same six PDF assets where labels match (per product choice). */
export const EXPLORER_WHITELABEL_DOCUMENTS: ExplorerDocumentItem[] = [
  {
    id: 'wl-cancellation',
    label: 'Cancellation Form User Online Backup.pdf',
    size: '69.70 kB',
    slug: 'cancellation-form-user-online-backup.pdf',
  },
  {
    id: 'wl-iso27001',
    label: 'ISO 27001 Certificaat.pdf',
    size: '2.22 MB',
    slug: 'iso-27001-certificate.pdf',
  },
  {
    id: 'wl-msp',
    label: 'MSP Agreement.pdf',
    size: '2.38 MB',
    slug: 'msp-agreement.pdf',
  },
  {
    id: 'wl-nen7510',
    label: 'NEN 7510 Certificaat.pdf',
    size: '2.27 MB',
    slug: 'nen-7510-certificate.pdf',
  },
];

export function explorerDocumentPublicUrl(slug: string): string {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  return `${base}/docs/mindtime-explorer/${slug}`;
}
